import { importJSON } from "../../../lib/importJSON";

export type ListName = "FormList";

export type FormListItem = {
    FileNum: string,
    FileName: string,
    HasSample: boolean,
    FileLink: string,
}


function setFormList<T extends unknown>(
    data: any[],
    setData: (data: FormListItem[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
    setSearchData: React.Dispatch<React.SetStateAction<FormListItem[]>>
) {
    let initObj: FormListItem = {
        FileNum: "",
        FileName: "",
        HasSample: false,
        FileLink: "",
    };
    if (data && data.length > 0) {
        const parsedData = data.map((file) => importJSON(file, initObj)) as FormListItem[];
        setHasMoreData(data.length >= process.env.REACT_APP_FILELIST_PAGE_SIZE);
        setData(parsedData);
        setSearchData(parsedData);
    }
}

export function handleSetData<T extends unknown>(
    listName: ListName,
    data: T[],
    setData: (data: FormListItem[]) => void,
    setHasMoreData: React.Dispatch<React.SetStateAction<boolean>>,
    setSearchData: React.Dispatch<React.SetStateAction<FormListItem[]>>
) {
    switch (listName) {
        case "FormList":
            setFormList(
                data,
                setData,
                setHasMoreData,
                setSearchData
            );
            break;
    }
}